import getConfig from 'next/config';

interface IStartScenarioConfig {
  scenarioName?: string;
  defaultUrl: string;
}

export const getStartScenarioConfig = (): IStartScenarioConfig => {
  const { creditFullDealWeb, environment } = getConfig().publicRuntimeConfig;
  const scenarioFromQuery = new URLSearchParams(window.location.search).get('scenario');
  const scenarioName = environment === 'production' ? undefined : scenarioFromQuery || undefined;

  return {
    scenarioName,
    defaultUrl: creditFullDealWeb,
  };
};
